const util = {}
util.setTitle = (title) => {
  title = title || '国恒智慧能源服务有限公司'
  window.document.title = title
  var i = document.createElement('iframe')
  // i.src = '//m.baidu.com/favicon.ico'
  i.style.display = 'none'
  i.onload = () => {
    setTimeout(() => {
      i.remove()
    }, 9)
  }
  document.body.appendChild(i)
}
util.isAndroid = () => {
  const userAgentInfo = navigator.userAgent
  return userAgentInfo.indexOf('Android') > 0
}
export default util
